import { useFormikContext } from 'formik';
import { DueDateField } from '../../components';
import { useRfiFormField } from '../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { RfiCreateFormValues } from '../types';

const nowInIsoString = new Date().toISOString();

const DueDate = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const fieldName = ISSUE_ATTRIBUTE_NAMES.DUE_DATE;
  const { isFieldsMandatory, errorMessage, isSubmitting, fieldRef } = useRfiFormField(fieldName);
  const dateValue = formik.values[fieldName] || null;

  return (
    <DueDateField
      required={isFieldsMandatory}
      error={errorMessage}
      ref={fieldRef}
      date={dateValue}
      onChange={(date) => {
        formik.setFieldValue(fieldName, date);
      }}
      disabled={isSubmitting}
      rfiCreatedAt={nowInIsoString}
    />
  );
};
export default DueDate;
